import React from 'react'
import { Button } from '@sketch/components'
import {
  Container,
  ButtonWrapper,
  StyledBody,
  LearnMoreButton,
  StyledIcon,
  StyledHeading,
} from './WorkspaceSettingsUpsell.styles'
import { SKETCH_WEBSITE } from '@sketch/env-config'
import { ReactComponent as ShieldIcon } from '@sketch/icons/shield-48'

const WorkspaceSettingsSsoUpsell = () => {
  return (
    <Container>
      <div>
        <StyledIcon as={ShieldIcon} />
      </div>
      <div>
        <StyledHeading>Upgrade Sketch to Scale with Your Team</StyledHeading>
        <StyledBody>
          Get Single Sign-On (SSO), Permissions Groups, and a Permissions
          Directory that gives you full visibility over Workspace permissions
          with the Professional Plan.
        </StyledBody>
        <ButtonWrapper>
          <Button
            variant="primary"
            onClick={() => window.open(`${SKETCH_WEBSITE}/support/contact/`)}
          >
            Contact Us
          </Button>
          <LearnMoreButton
            onClick={() => window.open(`${SKETCH_WEBSITE}/pricing/`)}
          >
            View Plans
          </LearnMoreButton>
        </ButtonWrapper>
      </div>
    </Container>
  )
}

export { WorkspaceSettingsSsoUpsell }
